<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>


        <div class="bolck_box">
            <a-card  size="small" title="">
                <a-row>
                    <a-col :span="4">

                    </a-col>
                    <a-col :span="16">
                        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout">
                            <a-form-model-item  label="通道类型编码" ref="passwaytype"  prop="passwaytype">
                                <a-input v-if="is_vue_task" v-model="record.passwaytype" @blur=" () => {$refs.passwaytype.onFieldBlur();}" />
                                <span v-else>{{record.passwaytype}}</span>
                            </a-form-model-item>
                            <a-form-model-item ref="passwaytypename" label="通道类型名称" prop="passwaytypename">
                                <a-input v-if="is_vue_task" v-model="record.passwaytypename" @blur=" () => {$refs.passwaytypename.onFieldBlur();}" />
                                <span v-else>{{record.passwaytypename}}</span>
                            </a-form-model-item>
                        </a-form-model>
                    </a-col>
                </a-row>

            </a-card>
        </div>



        <a-button v-if="is_vue_task"  type="primary" @click="handleOk" :loading="confirmLoading" style="display:block;margin:24px auto;">
            保存
        </a-button>
    </div>

</template>
<script>
const m_title = {
    'add_passwaytype':'新增通道类型',
    'detail_passwaytype':'查看通道类型',
    'edit_passwaytype':'编辑业务类型',
};

export default {
    components:{
    },
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                passwaytype: [
                    { required: true, message: '请输入通道类型编码', trigger: 'blur' },
                ],
                passwaytypename:[
                    { required: true, message: '请输入通道类型名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                passwaytype:'',//--
                passwaytypename:'',//--
            }
        };
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.submitData();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        submitData(){
            this.confirmLoading = true;
            const { params } = this.$route;

            if(params.action == 'edit_passwaytype'){
                this.$store
                    .dispatch({
                        type: "mcmsmanager/updateMcmsPasswaytype",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
            else if(params.action == 'add_passwaytype'){
                this.record.id = '';
                //新增
                this.$store
                    .dispatch({
                        type: "mcmsmanager/insertMcmsPasswaytype",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.passwaytype = 'PASSTYPE-000'

        },

        getDetail(id){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/selectMcmsPasswaytypesOne",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    
                }
            });
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_passwaytype";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }

        this.is_vue_task = params.action != 'detail_passwaytype'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}


.bolck_box{
    padding: 20px;
}


</style>
